import _ from 'lodash'

class AccountManagementController {
  constructor(CurrentUserService, $routeParams, $location) {
    this.CurrentUserService = CurrentUserService
    this.$routeParams = $routeParams
    this.$location = $location
    this.path = 'account-management/page/'
    this.currentTab = $routeParams.page || 'alerts'
  }

  activateTab(tab) {
    this.$location.path(this.path+tab)
  }

  isActive(tab) {
    return tab === this.$routeParams.page
  }
}

AccountManagementController.$inject = ['CurrentUserService', '$routeParams', '$location']

export default AccountManagementController
